// @ts-check
import TopNav from './TopNav';

export default TopNav;
